import React, { useMemo } from "react";
import "./MetallicCard.css";
import useAdminDataStore, { selectCurrentGroupData } from "../../../../../store/adminData/adminData";
import { isLightColor } from "../../../../../utils/colors";

const MetallicCard = ({ type = "singleTone", onClick }) => {
  const groupData = useAdminDataStore(selectCurrentGroupData);

  const secondaryColor = useMemo(() => {
    if (isLightColor(groupData?.configuration?.secondaryColor, 0.3)) {
      return "#000000";
    }

    return "#ffffff";
  }, [groupData]);

  return (
    <div onClick={onClick}>
      {type === "singleTone" ? (
        <div className="metallic-membership-card-single-tone">
          <div className="membership-card-single-tone-header">
            {groupData?.groupName}
          </div>
          <MetallicCardGroupLogo
            groupLogo={groupData?.configuration?.logo}
            isTransparent={groupData?.configuration?.isLogoTransparent}
          />
        </div>
      ) : (
        <div className="metallic-membership-card-dual-tone">
          <div className="membership-card-dual-tone-header">
            {groupData?.groupName}
          </div>
          <MetallicCardGroupLogo
            groupLogo={groupData?.configuration?.logo}
            isTransparent={groupData?.configuration?.isLogoTransparent}
          />
          <div className="metallic-membership-card-banner">
            {Array.from({ length: 3 }, (_, index) => (
              <div
                className="metallic-membership-card-banner-text-container"
                key={index}
              >
                {Array.from({ length: 10 }, (_, index) => (
                  <span
                    className="metallic-membership-card-banner-text"
                    key={index}
                    style={{ color: secondaryColor }}
                  >
                    {groupData?.groupName} •{" "}
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MetallicCard;

const MetallicCardGroupLogo = ({ groupLogo, isTransparent = false }) => {
  return (
    <div style={{ width: "100%" }} className="flex-center">
      <div
        className={`metallic-membership-card-logo-container${isTransparent ? "--transparent" : "--regular"}`}
      >
        <img
          className="metallic-membership-card-logo-container-image"
          src={groupLogo}
          alt="Membership Card Logo"
        />
      </div>
    </div>
  );
};
